import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;
let inflight = null;
const listeners = new Set();

export const refreshPlanAccess = async () => {
  if (inflight) return inflight;
  inflight = axios.get(`${API}/subscription`)
    .then(({ data }) => {
      cache = data;
      listeners.forEach((fn) => fn(data));
      return data;
    })
    .catch(() => cache)
    .finally(() => { inflight = null; });
  return inflight;
};

export const usePlanAccess = () => {
  const [sub, setSub] = useState(cache);
  const { pathname } = useLocation();

  useEffect(() => {
    listeners.add(setSub);
    return () => listeners.delete(setSub);
  }, []);

  useEffect(() => {
    refreshPlanAccess();
  }, [pathname]);

  return sub;
};
